import {
  getAvailabilityMinSkuQuantity,
  getExportedMinSkuQuantity,
  getUsedUnitQuantityFromMinSku,
  resolveExportBySku,
} from "app/common/inventoryUtils";
import { LEAD_SOURCE_LEVEL, PAGESIZE_ALL, TREATMENT_FREE, TYPE_CARD } from "app/common/LocalConst";
import { getPriceTypeService } from "app/common/LocalFunction";
import { RegisterService } from "app/common/Model/RegisterService";
import { RequestStoreExportProducts } from "app/common/Model/RequestStoreExportProducts";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingClientCard } from "app/services/ClientCardService";
import { getListCode } from "app/services/CustomerSourceService";
import { pagingDrugOrderHistory } from "app/services/DrugOrderHistoryService";
import { pagingDrugOrder } from "app/services/DrugService";
import { elasticDrugOrderHistory } from "app/services/ElasticPatient";
import { lockProduct, saveProductRequest } from "app/services/EncounterService";
import { changePaSvRes } from "app/services/PatientServiceRegisterService";
import {
  getListDrugOrderAdvicePatient,
  initChangeProduct,
  unLockProduct,
} from "app/services/ProductService";
import {
  exportProductsFromHis,
  fetchProductSkus,
  fetchStockAvailabilityForProducts,
  getListStoreRequestItem,
  getReturnExportTransactionsByDrugOrder,
  getReturnSummaryByDrugOrderAndExportTx,
  saveRequestOutpatientRefund,
} from "app/services/StoreRequestService";
import {
  getDrugOderById,
  removeDrug,
} from "app/services/TreatmentPlanCardService";
import { pagingProgram } from "app/services/PromotionCRMService";
import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
export default class RegisterProductStore {
  searchRegisterProduct = {
    ...new SearchObject(),
    fromDate: new Date(new Date().getFullYear(), 0, 1),
    toDate: new Date(),
    type: TYPE_CARD[0].value,
    orderDate: new Date(),
    chosenProducts: [],
  };
  dataRegisterProduct = [];
  openConfirmDelete = null;
  openConfirmMessage = null;
  openConfirmDeleteMessage = null;
  openUpdateProductAdvicePopup = false;
  openAddProductAdvicePopup = false;
  searchListProductAdvice = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
  };
  openCreateOrEditProductPopup = false;
  openRequestStoreExportProductsPopup = false;
  openListStoreRequestItemPopup = false;
  // Hoàn trả hàng (2026-07-09) — popup hoàn trả theo drugOrder đã xuất kho.
  openReturnProductPopup = false;
  selectedReturnDrugOrder = null;
  returnExportTransactions = []; // danh sách phiếu xuất kho còn hoàn (bước chọn)
  pickedReturnExportTx = null;     // phiếu xuất user đã chọn (chưa tải)
  selectedReturnExportTx = null;   // phiếu xuất đã tải thông tin xong
  returnInfoLoaded = false;
  returnableLines = [];          // chi tiết lô sau khi tải thông tin
  returnLoading = false;
  returnLinesLoading = false;
  returnSubmitting = false;
  resetSlected = false;
  pageRegisterProduct = new PageResponse();
  initRegisterProduct = { ...new RegisterService() };
  initRequestStoreExportProducts = { ...new RequestStoreExportProducts() };
  initListStoreRequestItem = null;
  selectedProductOrders = [];
  printContent = [];
  openProductHistoryPopup = false;
  openChangeProductPopup = false;
  openConfirmUnlock = null;
  openConfirmError = null;
  openConfirmLock = null;
  initChangeProduct = {
    oldPatientServiceRegisterDto: {
      ...new RegisterService(),
    },
    newPatientServiceRegisterDto: {
      ...new RegisterService(),
    },
  };
  searchProductHistory = {
    ...new SearchObject(),
    drugOrderId: null,
  };
  dataProductHistory = [];
  selectProductOrderId = null;
  treatmentFree = null;

  openHistoryProductPopup = false;
  searchDataHistory = null;
  pageDataHistory = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  pagingRegisterProduct = async () => {
    let { orderDate, ...ortherData } = this.searchRegisterProduct;
    return await pagingDrugOrder({ ...ortherData, getStaffRevenues: true })
      .then(({ data }) => {
        this.pageRegisterProduct = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu sản phẩm có lỗi");
      });
  };
  setSelectedProductOrders = (list) => {
    this.selectedProductOrders = list;
  };

  saveOrUpdateRegisterProduct = async (values) => {
    return await saveProductRequest({ drugOrder: values })
      .then(({ data }) => {
        if (data?.drugOrder?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.drugOrder?.responseDetail;
          }, 500);
          return data;
        } else {
          if (data?.drugOrder?.id) {
            toast.success("Đăng ký sản phẩm thành công");
            if (values?.isContinue) {
              this.initRegisterProduct = {
                ...new RegisterService(),
                department: values?.department,
                staffRevenues: [],
              };
              return data;
            } else {
              this.openCreateOrEditProductPopup = false;
              this.pagingRegisterProduct();
              this.resetSelectedProducts(!this.resetSlected);
              return data;
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin đăng ký sản phẩm có lỗi");
      });
  };
  resetSelectedProducts = (state) => {
    this.resetSlected = state;
  };

  saveOrUpdateProductAdvice = async (values) => {
    return await saveProductRequest({ drugOrder: values })
      .then(({ data }) => {
        this.openUpdateProductAdvicePopup = false;
        toast.success("Đăng ký thuốc từ tư vấn thành công");
        getListDrugOrderAdvicePatient(this.searchListProductAdvice).then(
          ({ data }) => {
            this.dataRegisterProduct = data;
          }
        );
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin đăng ký thuốc từ tư vấn có lỗi");
      });
  };

  handleChangeFormSearchProduct = (searchRegisterProduct) => {
    this.searchRegisterProduct = {
      ...this.searchRegisterProduct,
      ...searchRegisterProduct,
    };
    this.pagingRegisterProduct();
  };

  handleChangeFormSearchProductAdvice = (obj) => {
    this.searchListProductAdvice = {
      ...this.searchListProductAdvice,
      ...obj,
    };
    this.pagingRegisterProductAdvice();
  };

  pagingRegisterProductAdvice = async () => {
    return await getListDrugOrderAdvicePatient({
      ...this.searchListProductAdvice,
    })
      .then(({ data }) => {
        this.dataRegisterProduct = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu sản phẩm có lỗi");
      });
  };

  handleAddProductAdvicePopup = async (data, patient, customerSourceWalkIn) => {
    let { drug, paiPatientTypeService, ...ortherData } = data;
    let currentConsultant = patient?.currentConsultant;
    let currentTelesale = patient?.currentTelesale || patient?.currentTelesale2;

    ortherData.usedUnit = drug?.unit;

    let feeItem;
    if (paiPatientTypeService && drug?.drugUnitPrices?.length > 0) {
      feeItem = drug?.drugUnitPrices?.find(
        (el) => el?.patientTypeService?.id === paiPatientTypeService?.id
      );
    } else {
      feeItem =
        drug?.drugUnitPrices?.length > 0
          ? getPriceTypeService(data?.patientTypeService, drug?.drugUnitPrices)
          : null;
    }

    const price = feeItem?.price || drug?.price;

    ortherData.price = price;
    ortherData.priceWithTax = feeItem?.isTaxIncluded;
    ortherData.patientTypeService = {
      ...feeItem?.patientTypeService,
      price: feeItem?.price,
    };
    const quantity = data?.soldQuantity || 1;

    let taxPercent = feeItem?.serviceVAT?.vatPercent?.toString() || 0;
    ortherData.taxPercent = taxPercent;

    let taxTotal;
    if (feeItem?.isTaxIncluded) {
      taxTotal =
        ((feeItem?.price * quantity - data?.discount) / (+taxPercent + 100)) *
        +taxPercent;
    } else {
      taxTotal =
        (feeItem?.price * quantity - data?.discount) *
        ((+taxPercent || 0) / 100);
    }
    ortherData.taxTotal = taxTotal;
    ortherData.totalAmount = quantity * price;

    let revenueAllocations = drug?.revenueAllocations;
    if (revenueAllocations) {
      let staffRevenues = revenueAllocations?.map((el) => ({
        position: el?.position,
        percentRevenue: el?.commissionRate,
        source: patient?.currentPatientSource
          ? patient?.currentPatientSource
          : customerSourceWalkIn,
        staff:
          currentConsultant?.position?.code === el?.position?.code
            ? currentConsultant
            : currentTelesale?.position?.code === el?.position?.code
              ? currentTelesale
              : null,
      }));
      ortherData.staffRevenues = staffRevenues;
    } else {
      ortherData.staffRevenues = [];
    }
    this.initRegisterProduct = { ...ortherData, drug };
    this.openUpdateProductAdvicePopup = true;
  };

  handleOpenCreateOrEditCardPopup = async (productRegister, patient, defaultDepartment) => {
    let searchCodeSource = {};
    if (Boolean(productRegister)) {
      getDrugOderById(productRegister?.id).then(async ({ data }) => {
        if (data?.taxPercent) data.taxPercent = data?.taxPercent?.toString();

        // Fetch full CTKM data if promotionProgram exists
        if (data?.promotionProgram?.code) {
          try {
            const { data: ctkmResponse } = await pagingProgram({
              codes: [data.promotionProgram.code],
              pageSize: 10,
            });
            const ctkmList = ctkmResponse?.content || [];
            const fullCtkm = ctkmList?.find(
              (c) => c?.code === data?.promotionProgram?.code
            );
            if (fullCtkm) {
              data.promotionProgram = fullCtkm;
            }
          } catch (error) {
            console.error("Error fetching full CTKM data:", error);
          }
        }

        this.initRegisterProduct = {
          ...data,
          isDisabled: productRegister?.isDisabled,
        };
        this.openCreateOrEditProductPopup = true;
        searchCodeSource = {
          level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
          visitId: this.initRegisterProduct?.visitId,
          patientId: patient?.id || this.initRegisterProduct?.patientId,
          departmentId: this.initRegisterProduct?.department?.id,
          voucherIds: this.initRegisterCard?.voucherAllocations?.map(item => item?.voucher?.id) || [],
          invoiceItemIds: this.initRegisterCard?.invoiceItemAllocations?.map(item => item?.invoiceItem?.id) || []
        }
        this.handleGetListCodeSource(searchCodeSource)
      });
    } else {
      this.initRegisterProduct = { ...new RegisterService() };
      this.openCreateOrEditProductPopup = true;
      searchCodeSource = {
        level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
        startDate: this.initRegisterProduct?.orderDate || new Date(),
        patientId: patient?.id || this.initRegisterProduct?.patientId,
        departmentId: defaultDepartment?.id,
      }
      this.handleGetListCodeSource(searchCodeSource)
    }
  };

  listCodeSource = [];
  handleGetListCodeSource = async (obj) => {
    try {
      const { data } = await getListCode(obj);
      this.listCodeSource = data || [];
    } catch (error) {
      //console.error(error);
    }
  }

  handleOpenAddProductAdvicePopup = async (obj) => {
    this.searchListProductAdvice = { ...this.searchListProductAdvice, ...obj };
    this.pagingRegisterProductAdvice();
    this.openAddProductAdvicePopup = true;
  };

  handleCloseCreateOrEditProductPopup = () => {
    this.openCreateOrEditProductPopup = false;
    this.initRegisterProduct = { ...new RegisterService() };
    this.pagingRegisterProduct();
  };

  handleOpenListStoreRequestItemPopup = async (id) => {
    try {
      const { data } = await getListStoreRequestItem({ drugOrderId: id });
      this.initListStoreRequestItem = data;
      this.openListStoreRequestItemPopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  // Hoàn trả — giống STORE /return-request: chọn phiếu xuất → Tải thông tin → nhập SL.
  handleOpenReturnProductPopup = async (row) => {
    this.selectedReturnDrugOrder = row;
    this.openReturnProductPopup = true;
    this.returnExportTransactions = [];
    this.pickedReturnExportTx = null;
    this.selectedReturnExportTx = null;
    this.returnInfoLoaded = false;
    this.returnableLines = [];
    if (!row?.id) return;
    this.returnLoading = true;
    try {
      const { data } = await getReturnExportTransactionsByDrugOrder(row.id);
      runInAction(() => {
        this.returnExportTransactions = data || [];
      });
    } catch (error) {
      console.error(error);
      toast.error("Không tải được danh sách phiếu xuất để hoàn trả");
    } finally {
      runInAction(() => {
        this.returnLoading = false;
      });
    }
  };

  /** Chỉ chọn phiếu xuất — chưa gọi API chi tiết (bước 1). */
  handlePickReturnExportTx = (tx) => {
    if (!tx?.storeTransactionId) return;
    if (
      this.returnInfoLoaded &&
      this.selectedReturnExportTx?.storeTransactionId &&
      this.selectedReturnExportTx.storeTransactionId !== tx.storeTransactionId &&
      (this.returnableLines?.length || 0) > 0
    ) {
      const ok = window.confirm(
        "Đổi phiếu xuất sẽ xóa dữ liệu đã tải. Bạn cần bấm「Tải thông tin」lại. Tiếp tục?"
      );
      if (!ok) return;
    }
    runInAction(() => {
      this.pickedReturnExportTx = tx;
      this.selectedReturnExportTx = null;
      this.returnInfoLoaded = false;
      this.returnableLines = [];
    });
  };

  /** Bấm「Tải thông tin」— nạp dòng lô còn hoàn của phiếu đã chọn (bước 2). */
  handleLoadReturnExportTxInfo = async () => {
    const drugOrder = this.selectedReturnDrugOrder;
    const tx = this.pickedReturnExportTx;
    if (!drugOrder?.id || !tx?.storeTransactionId) {
      toast.warning("Vui lòng chọn phiếu xuất kho trước");
      return;
    }
    this.returnLinesLoading = true;
    this.returnableLines = [];
    this.returnInfoLoaded = false;
    try {
      const { data } = await getReturnSummaryByDrugOrderAndExportTx(
        drugOrder.id,
        tx.storeTransactionId
      );
      runInAction(() => {
        this.returnableLines = data || [];
        this.returnInfoLoaded = true;
        this.selectedReturnExportTx = tx;
      });
      if (!data?.length) {
        toast.warning("Phiếu xuất này không còn hàng để hoàn");
      } else {
        toast.success(`Đã tải ${data.length} dòng — cập nhật số lượng cần trả`);
      }
    } catch (error) {
      console.error(error);
      toast.error("Không tải được chi tiết hoàn trả");
    } finally {
      runInAction(() => {
        this.returnLinesLoading = false;
      });
    }
  };

  handleBackReturnExportTxSelect = () => {
    this.pickedReturnExportTx = null;
    this.selectedReturnExportTx = null;
    this.returnInfoLoaded = false;
    this.returnableLines = [];
  };

  handleCloseReturnProductPopup = () => {
    this.openReturnProductPopup = false;
    this.selectedReturnDrugOrder = null;
    this.returnExportTransactions = [];
    this.pickedReturnExportTx = null;
    this.selectedReturnExportTx = null;
    this.returnInfoLoaded = false;
    this.returnableLines = [];
  };

  // Gửi yêu cầu hoàn trả sang HIS BE (BE: tạo YCHT kho → phiếu nhập NL).
  // items: [{ storeTransactionId, transItemId, stockUnitId, quantity }]
  handleSubmitReturnProducts = async ({ items, reason }) => {
    const drugOrder = this.selectedReturnDrugOrder;
    if (!drugOrder?.id) return false;
    const validItems = (items || []).filter((it) => it && it.quantity > 0);
    if (validItems.length === 0) {
      toast.warning("Nhập số lượng hoàn (> 0) cho ít nhất 1 dòng");
      return false;
    }
    this.returnSubmitting = true;
    try {
      const payload = {
        drugOrderId: drugOrder.id,
        patientId: drugOrder.patientId,
        reason: reason || "",
        items: validItems,
      };
      const { data } = await saveRequestOutpatientRefund(payload);
      const total = data?.totalGroups ?? 0;
      const success = data?.successGroups ?? 0;
      if (total > 0 && success === total) {
        const codes = (data?.results || [])
          .filter((r) => r?.returnRequestCode)
          .map((r) => r.returnRequestCode)
          .join(", ");
        toast.success(
          codes
            ? `Đã tạo yêu cầu hoàn trả ${codes} và hoàn ${success} phiếu`
            : `Đã hoàn trả ${success} phiếu`
        );
        this.handleCloseReturnProductPopup();
        await this.pagingRegisterProduct();
        return true;
      }
      // partial / all-failed: giữ popup, báo lỗi từng phiếu
      const failed = (data?.results || []).filter((r) => r && !r.success);
      const msg = failed
        .map((r) => `${r.exportTxCode || "?"}: ${r.errorMessage || "lỗi"}`)
        .join("; ");
      toast.warning(`Đã hoàn ${success}/${total} phiếu. Lỗi: ${msg || "không rõ"}`);
      await this.pagingRegisterProduct();
      return false;
    } catch (error) {
      console.error(error);
      toast.error("Hoàn trả thất bại");
      return false;
    } finally {
      runInAction(() => {
        this.returnSubmitting = false;
      });
    }
  };
  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };

  handleDeleteProduct = async () => {
    return await removeDrug(this.openConfirmDelete)
      .then(({ data }) => {
        this.openConfirmDelete = null;
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmDeleteMessage = data?.responseDetail;
          }, 500);
          return;
        } else {
          toast.success("Xóa sản phẩm thành công");
          this.pagingRegisterProduct();
          this.resetSelectedProducts(!this.resetSlected);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa sản phẩm có lỗi");
      });
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  handleCloseDeleteConfirmMessage = () => {
    this.openConfirmDeleteMessage = null;
  };

  handleCloseListStoreRequestItemPopup = () => {
    this.openListStoreRequestItemPopup = false;
  };

  handleCloseAddProductAdvicePopup = () => {
    this.openAddProductAdvicePopup = false;
  };

  handleCloseUpdateProductAdvicePopup = () => {
    this.openUpdateProductAdvicePopup = false;
  };

  handleOpenRequestStoreExportProductsPopup = ({
    department,
    patientId,
    selectedProductOrders,
  }) => {
    this.setSelectedProductOrders(selectedProductOrders);
    this.handleInitStoreRequest(department, department?.storeConfig, patientId);
    this.openRequestStoreExportProductsPopup = true;
  };

  handleInitStoreRequest = async (department, storeConfig, patientId) => {
    let selectedProductOrders = [...this.selectedProductOrders];
    const productCodes =
      selectedProductOrders?.map(
        (item) => item?.drug?.code || item?.medicalSupply?.code
      ) || [];

    try {
      // 1) Lấy SKU + hệ số quy đổi — KHÔNG phụ thuộc kho → quy đổi đơn vị được ngay cả khi chưa chọn kho.
      const skuData = await fetchProductSkus(productCodes);

      // 2) Lấy tồn kho — CHỈ khi đã chọn kho (tồn phụ thuộc kho).
      let availData = [];
      if (storeConfig?.code) {
        availData = await fetchStockAvailabilityForProducts(
          storeConfig.code,
          productCodes
        );
      }

      let items = [];
      items = this.selectedProductOrders?.map((item) => {
        const productCode =
          item?.drug?.code || item?.medicalSupply?.code;
        const skuInfo = skuData?.find((el) => el?.productCode === productCode);
        const availInfo = availData?.find(
          (el) => el?.productCode === productCode
        );

        // Quy đổi xuất kho theo đơn vị nhỏ nhất — map đơn vị qua mã (code) → hệ số + đơn vị nhỏ nhất.
        // Dùng skuInfo (không phụ thuộc kho).
        const exportBySku = resolveExportBySku(skuInfo, item?.usedUnit);

        // Tồn theo đơn vị nhỏ nhất (chỉ có khi đã chọn kho); quy đổi sang đơn vị tính bằng hệ số.
        const availMinSku = availInfo
          ? getAvailabilityMinSkuQuantity(availInfo)
          : null;

        return {
          // Tồn quy theo đơn vị tính = tồn(đơn vị nhỏ nhất) ÷ hệ số. Chưa chọn kho → null ("—").
          inventoryQuantity:
            availMinSku != null
              ? getUsedUnitQuantityFromMinSku(
                  availMinSku,
                  exportBySku.coefficient
                )
              : null,
          // Tồn theo đơn vị nhỏ nhất (để hiển thị, vd 200 Tuýp)
          inventoryMinSkuQuantity: availMinSku,
          drug: {
            name: item?.drug?.name,
            code: item?.drug?.code,
            id: skuInfo?.productId || availInfo?.productId,
          },
          usedUnit: item?.usedUnit,
          productName: item?.drug?.name,
          productCode: item?.drug?.code,
          drugOrderId: item?.id,
          soldQuantity: item?.soldQuantity,
          exportedQuantity: item?.exportedQuantity,
          exportedCurrentQuantity: 0,
          // Quy đổi đơn vị nhỏ nhất (2026-07-08)
          coefficient: exportBySku.coefficient, // trọng số (số ĐV nhỏ nhất trong 1 ĐV tính)
          exportUnitCode: exportBySku.exportUnitCode, // mã đơn vị xuất (minSku)
          exportUnitName: exportBySku.exportUnitName, // tên đơn vị xuất (minSku)
          exportUnitResolved: exportBySku.resolved, // map được hệ số qua mã?
          exportedMinSkuQuantity: 0, // SL xuất theo ĐV nhỏ nhất = exportedCurrentQuantity × coefficient
          item,
        };
      });
      this.initRequestStoreExportProducts = {
        department,
        patientId,
        store: storeConfig,
        dateIssue: new Date(),
        items,
      };
    } catch (error) {
      console.error(error);
      toast.error("Lấy tồn kho từ Store có lỗi");
    }
  };

  handleExportProductsFromHis = async (values) => {
    if (!values?.department?.id) {
      toast.error("Chưa chọn cơ sở!");
      return;
    }
    if (!values?.store?.id && !values?.store?.code) {
      toast.error("Chưa chọn kho yêu cầu!");
      return;
    }
    if (!values?.dateIssue) {
      toast.error("Chưa chọn ngày yêu cầu!");
      return;
    }

    const items = (values?.items || []).filter(
      (it) => Number(it?.exportedCurrentQuantity) > 0
    );
    if (items.length === 0) {
      toast.error(
        "Vui lòng nhập số lượng xuất lớn hơn 0 cho ít nhất một sản phẩm!"
      );
      return;
    }

    // Quy đổi SL xuất theo đơn vị nhỏ nhất trước khi gửi kho (2026-07-08).
    // Chặn item chưa map được hệ số qua mã đơn vị → tránh trừ sai kho.
    const unresolved = items.filter(
      (it) => (it?.exportedCurrentQuantity || 0) > 0 && !it?.exportUnitResolved
    );
    if (unresolved.length > 0) {
      const names = unresolved
        .map((it) => it?.drug?.name || it?.productName || it?.productCode)
        .join(", ");
      toast.error(
        `Chưa xác định được hệ số quy đổi đơn vị cho: ${names}. Không thể xuất.`
      );
      return;
    }
    const payload = {
      ...values,
      items: items.map((it) => ({
        ...it,
        exportedMinSkuQuantity: getExportedMinSkuQuantity(
          it?.exportedCurrentQuantity,
          it?.coefficient
        ),
      })),
    };

    this.resetSlected = !this.resetSlected;
    try {
      let { data } = await exportProductsFromHis(payload);
      if (data) {
        if (data?.responseStatus === false) {
          toast.error(data?.responseDetail || "Xuất kho không thành công");
          setTimeout(() => {
            this.openConfirmError = data?.responseDetail;
          }, 500);
        } else {
          this.openRequestStoreExportProductsPopup = false;
          this.pagingRegisterProduct();
          toast.success("Yêu cầu xuất kho thành công");
        }
      } else {
        toast.error("Xuất kho lỗi");
      }
      this.resetSlected = !this.resetSlected;
      this.selectedProductOrders = [];
    } catch (error) {
      toast.error("Xuất kho lỗi");
      console.log("lỗi xuất kho", error);
    }
  };

  handleCloseRequestStoreExportProductsPopup = () => {
    this.openRequestStoreExportProductsPopup = false;
    // this.selectedProductOrders = [];
  };

  handleSetPrintContent = (printContent) => {
    this.printContent = printContent;
  };

  resetPopupStore = () => {
    this.initRegisterProduct = { ...new RegisterService() };
  };

  handleOpenProductHistoryPopup = () => {
    this.openProductHistoryPopup = true;
  };

  handleCloseProductHistoryPopup = () => {
    this.openProductHistoryPopup = false;
  };

  handleChangeFormSearchProductHistory = (searchProductHistory) => {
    this.searchProductHistory = {
      ...this.searchProductHistory,
      ...searchProductHistory,
    };
    this.fetchPagingProductHistory();
  };

  fetchPagingProductHistory = async () => {
    return await pagingDrugOrderHistory({
      ...this.searchProductHistory,
    })
      .then(({ data }) => {
        this.dataProductHistory = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử sản phẩm có lỗi");
      });
  };

  setSelectProductOrderId = (id) => {
    this.selectProductOrderId = id;
  };

  handleOpenChangeProductPopup = async (product, patient) => {
    try {
      let searchCodeSource = {};
      const { data } = await initChangeProduct(product?.id);
      if (data) {
        let { oldProduct } = data;
        // const formatStaffRevenues = oldProduct?.staffRevenues?.map((el) => ({
        //   ...el,
        //   actualAmount: 0,
        //   oldPercentRevenue: el?.percentRevenue,
        // }));
        this.initChangeProduct = {
          oldProduct,
          //staffRevenues: formatStaffRevenues,
          staffRevenues: [],
          remainingQuantity: oldProduct?.remainingQuantity,
          oldCredit: oldProduct?.remainingAmount,
          quantity: 1,
          clientCard: this.treatmentFree,
          startDate: new Date(),
          ...data,
        };
        this.openChangeProductPopup = true;
        searchCodeSource = {
          level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
          startDate: this.initChangeProduct?.startDate || new Date(),
          patientId: patient?.id,
          departmentId: oldProduct?.department?.id || product?.department?.id,
        };
        this.handleGetListCodeSource(searchCodeSource);
      }
    } catch (error) {
      toast.error("Lấy thông tin sản phẩm có lỗi");
    }
  };

  handleCloseChangeeProductPopup = () => {
    this.openChangeProductPopup = false;
  };

  handleSubmitChangeProduct = async (values) => {
    try {
      let { newProduct, oldProduct, ...ortherData } = values;
      let obj = {
        oldProduct,
        newTreatmentPlanCard: ortherData,
      };

      const { data } = await changePaSvRes(obj);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmMessage = data?.responseDetail;
        }, 500);
        return data;
      } else {
        this.openChangeProductPopup = false;
        this.pagingRegisterProduct();
        toast.success("Đổi sản phẩm thành công");
      }
    } catch (error) {
      console.error(error);
      toast.error("Đổi sản phẩm có lỗi");
    }
  };

  handleOpenConfirmUnlock = (id) => {
    this.openConfirmUnlock = id;
  };

  handleCloseConfirmUnlock = () => {
    this.openConfirmUnlock = null;
  };

  handleOpenConfirmError = () => {
    this.openConfirmError = null;
  };

  handleConfirmUnlock = async () => {
    try {
      const { data } = await unLockProduct(this.openConfirmUnlock);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmError = data?.responseDetail;
        }, 300);
      } else {
        toast.success("Mở khóa thành công");
        this.pagingRegisterProduct();
      }
      this.openConfirmUnlock = null;

      this.pagingAllServices();
    } catch (error) {
      toast.error(error);
    }
  };

  handleOpenConfirmlock = (id) => {
    this.openConfirmLock = id;
  };

  handleCloseConfirmLock = () => {
    this.openConfirmLock = null;
  };

  handleConfirmLock = async () => {
    try {
      const { data } = await lockProduct(this.openConfirmLock);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmError = data?.responseDetail;
        }, 300);
      } else {
        toast.success("Khóa thành công");
        this.pagingRegisterProduct();
      }
      this.openConfirmLock = null;
    } catch (error) {
      toast.error(error);
    }
  };
  getTreatmentFree = async () => {
    return await pagingClientCard({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      keyword: TREATMENT_FREE,
      type: TYPE_CARD[1].value,
    })
      .then(({ data }) => {
        this.treatmentFree = data?.content?.[0];
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu liệu trình tùy chỉnh có lỗi");
      });
  };

  handleCloseHistoryProductPopup = async () => {
    this.openHistoryProductPopup = false;
    this.searchDataHistory = null;
  };

  handleChangeFormSearchHistory = (searchDataHistory) => {
    this.searchDataHistory = {
      ...this.searchDataHistory,
      ...searchDataHistory,
    };
    this.pagingHistory();
  };

  pagingHistory = async () => {
    return await elasticDrugOrderHistory({
      ...this.searchDataHistory,
    })
      .then(({ data }) => {
        this.pageDataHistory = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử sản phẩm có lỗi");
      });
  };

  handleOpenHistoryProductPopup = async (values) => {
    try {
      this.handleChangeFormSearchHistory(values);
      this.openHistoryProductPopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  resetStore = () => {
    this.searchRegisterProduct = {
      ...new SearchObject(),
      fromDate: new Date(new Date().getFullYear(), 0, 1),
      toDate: new Date(),
      type: TYPE_CARD[0].value,
      orderDate: new Date(),
    };
    this.pageRegisterProduct = new PageResponse();
    this.openCreateOrEditProductPopup = false;
    this.initRegisterProduct = { ...new RegisterService() };
    this.openConfirmMessage = null;
    this.dataRegisterProduct = [];
    this.searchListProductAdvice = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
    this.openRequestStoreExportProductsPopup = false;
    this.openProductHistoryPopup = false;
    this.selectProductOrderId = null;
  };
}
